import { render, staticRenderFns } from "./createGoodsRules.vue?vue&type=template&id=12dee6e4&scoped=true"
import script from "./createGoodsRules.vue?vue&type=script&lang=js"
export * from "./createGoodsRules.vue?vue&type=script&lang=js"
import style0 from "./createGoodsRules.vue?vue&type=style&index=0&id=12dee6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dee6e4",
  null
  
)

export default component.exports